export const SEARCH_PARAM_UNIT_ID = 'unitId'
export const SEARCH_PARAM_COMPONENT_ID = 'componentId'
export const SEARCH_PARAM_INSPECTION_ID = 'inspectionId'
export const SEARCH_PARAM_CDF = 'cdf'
